import { render, staticRenderFns } from "./ProjImport.vue?vue&type=template&id=97e20bea&scoped=true"
import script from "./ProjImport.vue?vue&type=script&lang=js"
export * from "./ProjImport.vue?vue&type=script&lang=js"
import style0 from "./ProjImport.vue?vue&type=style&index=0&id=97e20bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e20bea",
  null
  
)

export default component.exports